import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, ToastModule],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    host: {
      style: 'background-color: #f0f0f0;'
    }
})
export class AppComponent {
  title = 'declarabid-private';
}
